import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { studyLabManagementFileServices } from "../../../../APIServices/studyLabManagementFileServices";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { handleResponse } from "../../../../APIHelpers/Responses";

const UpdateStudyLabFile = ({
  fileData,
  getStudyLabManagementData,
  Show,
  Hide,
  Title,
}) => {
  const { studyId } = useParams()
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [formId, setFormId] = useState("");
  const [mainVersion, setMainVersion] = useState("");
  const [formVersion, setFormVersion] = useState("");
  const [datasetType, setDatasetType] = useState("");
  const [formList, setFormList] = useState([]);
  const [buttonLoader, setButtonLoader] = useState(false);

  const updateStudyLabManagementData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Study Lab File!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        const formData = new FormData();
        formData.append("id", fileData?._id);
        formData.append("studyId", studyId);
        formData.append("fileName", fileName);
        formData.append("formId", formId);
        formData.append("formVersion", formVersion);
        formData.append("datasetType", datasetType);
        formData.append("mode", StudyMode);

        if (file) {
          formData.append("file", file);
        }

        let data = await studyLabManagementFileServices.updateStudyLabManagementData(
          formData
        );
        if (data?.statusCode === 200) {
          getStudyLabManagementData();
          Hide();
        }
      }
      setButtonLoader(false);
    });
  };

  const getStudyLevelForm = async () => {
    let data = await studyLevelFormManagementServices.getStudyLevelForm(studyId, "edc", "active", StudyMode)
    setFormList(data?.data || [])
  }

  useEffect(() => {
    setFileName(fileData?.fileName);
    if (fileData?.formId) {
      let formData = formList?.find(item => item.formId === fileData?.formId)
      setFormId(formData?.formId);
      setMainVersion(formData?.version)
    }
    setFormVersion(fileData?.formVersion);
    setDatasetType(fileData?.datasetType || "");
  }, [fileData]);

  useEffect(() => {
    getStudyLevelForm()
  }, []);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold mb-1">
              Upload File (Replace File){" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>

            <Form.Control
              type="file"
              className="br3"
              accept=".csv,.xls,.xlsx"
              onChange={(e) => {
                const file = e.target.files[0];

                if (!file) {
                  setFile(null);
                  return;
                }

                const allowedExtensions = [".csv", ".xls", ".xlsx"];
                const extension = file.name
                  .substring(file.name.lastIndexOf("."))
                  .toLowerCase();

                if (!allowedExtensions.includes(extension)) {
                  handleResponse({
                    statusCode: 400,
                    customMessage: "Only CSV and Excel files are allowed."
                  });
                  e.target.value = "";
                  setFile(null);
                  return;
                }

                setFile(file);
              }}
            />
            {file && (
              <small className="text-muted d-block mt-1">
                {file.name}
              </small>
            )}
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              File Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setFileName(e.target.value)}
              value={fileName}
              className="br3"
              placeholder="Enter File Name"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold mb-1">
              Form{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              value={formId}
              onChange={(e) => { setFormId(e.target.value); setMainVersion(e.target[e.target.selectedIndex].title) }}
              style={{ fontSize: 12 }}
              className="br3"
            >
              <option value="">Select Form</option>
              {formList?.map((item, index) => (
                <option key={index} value={item?.formId} title={item?.version}>{item?.formName}</option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Dataset Type{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => setDatasetType(e.target.value)}
              className="br3"
              value={datasetType}
              style={{ fontSize: 12 }}
            >
              <option value="">Select Dataset Type</option>
              <option value="row">Row Dataset</option>
              <option value="column">Column Dataset</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Form Version{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => setFormVersion(e.target.value)}
              className="br3"
              value={formVersion}
              disabled={!mainVersion}
              style={{ fontSize: 12 }}
            >
              <option value="">Select Version</option>
              {Array.from({ length: mainVersion }, (_, i) => i + 1)?.reverse()?.map((versionNumber, index) => (
                <option key={index} value={versionNumber}>Version {versionNumber}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={!fileName || !formId || !formVersion || !datasetType || buttonLoader}
            className="updateProfile"
            onClick={(e) => updateStudyLabManagementData(e)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Updating...
              </div>
            ) : (
              "Update File"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateStudyLabFile;
